import { defineStore } from "pinia";
import { ref } from "vue";
import { courseApi } from "@/api/ilect-openapi-configuration";
import type { Course } from "@/openapi-ts";

export const useCourseStore = defineStore("course", () => {
  const course = ref<Course | null>(null);
  const courseId = ref<string | null>(null);
  const isLoading = ref(false);
  const pendingRequests = new Map<string, Promise<Course>>();

  function setCourse(data: Course, id?: string) {
    course.value = data;
    courseId.value = id ?? courseId.value;
  }

  function clearCourse() {
    course.value = null;
    courseId.value = null;
    isLoading.value = false;
  }

  async function fetchCourse(id: string): Promise<Course> {
    if (course.value && courseId.value === id) {
      return course.value;
    }

    const pendingRequest = pendingRequests.get(id);
    if (pendingRequest) {
      courseId.value = id;
      isLoading.value = true;
      return pendingRequest;
    }

    courseId.value = id;
    isLoading.value = true;
    const request = courseApi
      .courseRetrieve(id)
      .then((res) => {
        if (courseId.value === id) {
          setCourse(res.data, id);
        }
        return res.data;
      })
      .finally(() => {
        pendingRequests.delete(id);
        if (courseId.value === id) {
          isLoading.value = false;
        }
      });

    pendingRequests.set(id, request);
    return request;
  }

  return { course, courseId, isLoading, setCourse, clearCourse, fetchCourse };
});
